module.exports = __webpack_public_path__ + "peng_jiapu_bgc.png?e00ad2141708d0bda1d3f8ed744b0bda";